import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0;
`;

export const Header = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${(props) => props.theme.palette[300]};
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: ${(props) => props.theme.palette[100]};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.palette[300]};
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input[type="radio"] {
    cursor: pointer;
  }
`;

export const RadioLabel = styled.span`
  color: ${(props) => props.theme.palette[900]};
  font-size: 15px;
  line-height: 20px;
`;

export const PriceInfo = styled.div`
  padding: 16px;
  background: ${(props) => props.theme.palette[200]};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.palette[400]};
`;
